import { z } from 'zod';

/** Entities that support file attachments. */
export const ATTACHMENT_ENTITY_TYPES = ['journal_entry', 'check', 'deposit', 'invoice', 'bill', 'reconciliation', 'participation_session'] as const;
export type AttachmentEntityType = (typeof ATTACHMENT_ENTITY_TYPES)[number];

export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024; // 10 MB

export const uploadAttachmentInputSchema = z.object({
  fileName: z.string().trim().min(1).max(255),
  mimeType: z.string().trim().min(1).max(120),
  /** base64-encoded file contents (no data: prefix). */
  content: z.string().min(1),
});
export type UploadAttachmentInput = z.infer<typeof uploadAttachmentInputSchema>;

/** Attachment metadata (never includes the file bytes). */
export interface Attachment {
  id: string;
  companyId: string;
  entityType: AttachmentEntityType;
  entityId: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  sha256: string;
  createdAt: string;
}
